import React, { useState, useRef } from 'react';
import { authApi } from '../auth';

export default function Login({ onLogin }) {
  const [email,    setEmail]   = useState('');
  const [password, setPass]    = useState('');
  const [error,    setError]   = useState('');
  const [loading,  setLoading] = useState(false);

  const emailRef    = useRef(null);
  const passwordRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Read directly from DOM to handle browser autofill
    const emailVal    = emailRef.current?.value    || email;
    const passwordVal = passwordRef.current?.value || password;

    if (!emailVal || !passwordVal) {
      setError('Email and password are required');
      return;
    }
    setLoading(true); setError('');
    try {
      const r = await authApi.post('/auth/login', {
        email:    emailVal.trim().toLowerCase(),
        password: passwordVal,
      });
      const { token, user } = r.data;
      localStorage.setItem('salesai_token', token);
      localStorage.setItem('salesai_user',  JSON.stringify(user));
      onLogin && onLogin(user);
    } catch(err) {
      const detail = err.response?.data?.detail;
      if (Array.isArray(detail)) {
        setError(detail.map(e => e.msg || JSON.stringify(e)).join(', '));
      } else if (typeof detail === 'string') {
        setError(detail);
      } else {
        setError('Login failed. Check your email and password.');
      }
    } finally { setLoading(false); }
  };

  const ROLES = [
    { label:'Admin',    color:'#2563EB', bg:'#EFF6FF', border:'#BFDBFE' },
    { label:'Manager',  color:'#16A34A', bg:'#F0FDF4', border:'#BBF7D0' },
    { label:'Sales Rep',color:'#D97706', bg:'#FFFBEB', border:'#FDE68A' },
    { label:'Read Only',color:'#7C3AED', bg:'#F5F3FF', border:'#DDD6FE' },
  ];

  return (
    <div style={{
      minHeight:'100vh', background:'var(--bg)',
      display:'flex', alignItems:'center', justifyContent:'center', padding:16,
    }}>
      <div style={{width:'100%', maxWidth:420}}>

        {/* Logo */}
        <div style={{textAlign:'center', marginBottom:32}}>
          <div style={{width:56,height:56,background:'var(--blue)',borderRadius:16,
            display:'inline-flex',alignItems:'center',justifyContent:'center',
            fontSize:28,color:'#fff',marginBottom:14,boxShadow:'0 4px 14px rgba(37,99,235,.35)'}}>
            ✈
          </div>
          <h1 style={{fontSize:28,fontWeight:700,color:'var(--text)',margin:0}}>
            Sales<span style={{color:'var(--blue)'}}>AI</span>
          </h1>
          <p style={{color:'var(--text-2)',fontSize:14,marginTop:6}}>Sign in to your account</p>
        </div>

        {/* Card */}
        <div style={{background:'var(--surface)',borderRadius:16,
          border:'1px solid var(--border)',padding:'28px',
          boxShadow:'0 4px 24px rgba(0,0,0,.08)'}}>

          {error && (
            <div style={{background:'var(--red-bg)',border:'1px solid var(--red-border)',
              borderRadius:8,padding:'10px 14px',marginBottom:16,
              fontSize:13,color:'var(--red)',display:'flex',gap:8,alignItems:'center'}}>
              ⚠ {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email address</label>
              <input className="form-input" type="email" value={email}
                ref={emailRef}
                onChange={e=>setEmail(e.target.value)}
                placeholder="you@company.com" autoFocus style={{fontSize:14}}/>
            </div>
            <div className="form-group" style={{marginBottom:20}}>
              <label className="form-label">Password</label>
              <input className="form-input" type="password" value={password}
                ref={passwordRef}
                onChange={e=>setPass(e.target.value)}
                placeholder="••••••••" style={{fontSize:14}}/>
            </div>
            <button type="submit" className="btn btn-primary"
              disabled={loading}
              style={{width:'100%',justifyContent:'center',padding:'11px',fontSize:14,borderRadius:8}}>
              {loading
                ? <><span className="spinner spinner-sm"/>Signing in…</>
                : 'Sign in →'}
            </button>
          </form>
        </div>

        {/* Role pills */}
        <div style={{marginTop:14,display:'flex',gap:6,flexWrap:'wrap',justifyContent:'center'}}>
          {ROLES.map(r=>(
            <span key={r.label} style={{padding:'3px 12px',borderRadius:20,fontSize:11,
              fontWeight:500,background:r.bg,color:r.color,border:`1px solid ${r.border}`}}>
              {r.label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
